// import { login, logout, getInfo } from "@/api/user";
import { getToken, setToken, removeToken } from "@/utils/auth";
import router, { resetRouter } from "@/router";
import { LOGIN_AND_AUTH } from "@/api/user";
const state = {
  token: getToken(),
  name: "",
  menus: [],
  //   avatar: "",
  //   introduction: "",
  roles: [],
};

const mutations = {
  SET_TOKEN: (state, token) => {
    console.log("token", token);
    state.token = token;
  },
  //   SET_INTRODUCTION: (state, introduction) => {
  //     state.introduction = introduction;
  //   },
  SET_NAME: (state, name) => {
    state.name = name;
  },
  SET_MENUS: (state, menu) => {
    state.menus = menu;
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles;
  },
  //动态注册路由   不同的账号菜单不一样  能路由的地方不一样
  addMenu(state, router) {
    if (!localStorage.getItem("menu")) {
      return;
    }
    const menu = JSON.parse(localStorage.getItem("menu"));
    state.menus = menu;
    //组装动态路由的数据
    const menuArray = [];
    menu.forEach((item) => {
      //有子菜单
      if (item.children) {
        item.children = item.children.map((item) => {
          item.component = () => import(`../views/${item.url}`);
          return item;
        });
        menuArray.push(...item.children);
      } else {
        //无子菜单
        item.component = () => import(`../views/${item.url}`);
        menuArray.push(item);
      }
    });
    //路由的动态添加
    menuArray.forEach((item) => {
      router.addRoute("Main", item);
    });
  },
};

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { name, password } = userInfo;
    return new Promise((resolve, reject) => {
      LOGIN_AND_AUTH({ name: name?.trim(), password: password })
        .then(async (response) => {
          const { data } = response;
          // 菜单信息存到localstorage中，方便刷新页面后获取菜单信息
          localStorage.setItem("menu", JSON.stringify(data.data.menus));
          localStorage.setItem("roleList", JSON.stringify(data.data.roles));
          localStorage.setItem("pUserName", data.data.name);
          localStorage.setItem("pUserId", data.data.userId);
          resetRouter();
          commit("SET_TOKEN", data.data.token);
          setToken(data.data.token);

          commit("SET_ROLES", data.data.roles);
          commit("SET_NAME", data.data.name); //用户名
          commit("SET_MENUS", data.data.menus);
          commit("addMenu", router);
          //   console.log("router.getRoutes()", router.getRoutes());
          resolve();
        })
        .catch((error) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
